export default __webpack_public_path__ + "static/media/genericplayscreentablet.909f6b5b.png";